export default __webpack_public_path__ + "static/10B-8c55e5b6f858b239ed514adbfa0db156.png";